import React from 'react';
import Seo from '../components/common/Seo';
import AboutHero from '../components/about/AboutHero';
import awards_testimonials from '../assets/images/awards_testimonials.jpg';
import AwardsSection from '../components/awards/AwardsSection';
import TestimonialsSection from '../components/testimonials/TestimonialsSection';

const Awards = () => {
  return (
    <div className="w-full">
      <Seo
        title="Awards & Farmer Testimonials | Agastya Agro Limited"
        description="See the awards Agastya Agro has earned and read real feedback from farmers and partners who trust our crop protection portfolio."
      />
      {/* Hero Section with Component-based Design */}
      <AboutHero 
        heroImage={awards_testimonials}
        title="Agastya Agro's Awards & Testimonials"
        subtitle="Awards & Testimonials"
      />
      <AwardsSection />
      <TestimonialsSection />
    </div>
  );
};  

export default Awards;